const getAverageStatEmployees = (count: number) => {
  if (count === 0) return 0;
  let multiplier;
  if (count <= 1000) {
    multiplier = Math.round(count / 2);
  } else if (count <= 10000) {
    multiplier = Math.round(count / 3);
  } else if (count <= 200000) {
    multiplier = Math.round(count / 3);
  } else {
    multiplier = Math.round(count / 4);
  }
  return multiplier;
};

export default getAverageStatEmployees;
